import JaLayout from '@/components/feature/JaLayout';
import useSEO from '@/hooks/useSEO';
import { Link } from 'react-router-dom';

export default function JaTermsOfUsePage() {
  useSEO({
    title: '利用規約｜康永生技有限公司',
    description: '康永生技ウェブサイト利用規約：知的財産権、禁止事項、免責事項、お問い合わせフォーム利用規定、準拠法および管轄について記載しています。',
    keywords: '利用規約,ウェブサイト規約,康永生技,免責事項,知的財産権',
    lang: 'ja',
    canonicalPath: '/ja/terms-of-use',
  });

  return (
    <JaLayout>
      <div className="min-h-screen bg-white pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/ja" className="hover:text-gray-600 transition-colors cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line text-base" />
            <span className="text-gray-600">利用規約</span>
          </nav>

          {/* Header */}
          <div className="mb-10 pb-8 border-b border-gray-100">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">利用規約</h1>
            <p className="text-gray-400 text-sm">最終更新日：2025年1月</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. 規約への同意</h2>
              <p className="text-[0.9375rem]">
                康永生技有限公司（以下「当社」）のウェブサイトへようこそ。本ウェブサイトを利用することにより、
                お客様は本利用規約に同意したものとみなします。同意されない場合は、本ウェブサイトの利用をお控えください。
                当社は随時本規約を改訂する権利を留保し、改訂後の規約は公表時点より効力を生じます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. ウェブサイトの目的</h2>
              <p className="text-[0.9375rem] mb-3">本ウェブサイトは以下の情報・サービスを提供することを目的としています：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>当社の紹介、事業内容、サービス概要</li>
                <li>OEM/ODM製造サービスに関する情報</li>
                <li>ビジネスお問い合わせフォームおよび連絡機能</li>
                <li>健康食品業界に関する知識・法規情報</li>
              </ul>
              <p className="text-[0.9375rem] mt-3">
                本ウェブサイトの内容は商業的お問い合わせと情報参照のみを目的とし、
                法律・医療・健康上のアドバイスを構成するものではありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. 知的財産権</h2>
              <p className="text-[0.9375rem]">
                本ウェブサイトのすべてのコンテンツ（テキスト・画像・アイコン・ロゴ・デザイン・コード・レイアウト等を含むがこれに限らない）は、
                著作権その他の知的財産権法によって保護されており、その権利は当社に帰属します。
                当社の書面による事前許可なく、いかなる方法においても複製・配布・改変・表示・使用することはできません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. 禁止事項</h2>
              <p className="text-[0.9375rem] mb-3">本ウェブサイトを利用する際、お客様は以下の行為を行わないことに同意するものとします：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>ウェブサイトの正常な運営を妨害・阻害する行為</li>
                <li>本ウェブサイトを利用したスパムや無許可の商業メッセージの送信</li>
                <li>お問い合わせフォームへの虚偽または誤解を招く内容の送信</li>
                <li>ウェブサイトのシステムやデータベースへの不正アクセスの試み</li>
                <li>スクレイピング・クローリングその他自動化による大量コンテンツ取得</li>
                <li>適用される法令・規制への違反</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. 情報の正確性</h2>
              <p className="text-[0.9375rem]">
                当社はウェブサイト情報の正確性・最新性の確保に努めますが、すべての情報が完全・最新・
                誤りのないものであることを保証するものではありません。製品仕様・サービス内容・処方情報等は
                参考情報として提供されており、実際の協力の詳細は双方間の書面契約によって定められます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. 免責事項</h2>
              <p className="text-[0.9375rem]">
                法律で許可される最大限の範囲において、当社は本ウェブサイトの利用から生じるいかなる直接的・
                間接的損失に対しても責任を負いません。本ウェブサイトにはサードパーティウェブサイトへのリンクが
                含まれる場合がありますが、当社はそれらのコンテンツについて責任を負わず、
                アクセスはユーザーご自身の責任において行うものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. お問い合わせフォームの利用規定</h2>
              <p className="text-[0.9375rem]">
                お問い合わせフォームを送信することにより、提供する情報が真実かつ正確であることに同意したものとみなします。
                当社はプライバシーポリシーに従ってお客様の個人情報を取り扱います。
                当社は、明らかに悪意のある、または当社の事業性質に適合しないお問い合わせを
                拒否または無視する権利を留保します。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. 準拠法および管轄</h2>
              <p className="text-[0.9375rem]">
                本利用規約の解釈および適用は中華民国（台湾）の法律に準拠します。
                本規約または本ウェブサイトの利用に起因するすべての紛争については、
                台湾台中地方裁判所を第一審の専属的合意管轄裁判所とします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. お問い合わせ</h2>
              <p className="text-[0.9375rem]">本利用規約に関するご質問は、以下よりお問い合わせください：</p>
              <div className="mt-4 bg-gray-50 rounded-lg p-5 space-y-2 text-[0.9375rem]">
                <p><strong className="text-gray-900">Kang Yong Biotech Ltd.（康永生技有限公司）</strong></p>
                <p className="text-gray-600">台湾 台中市北区中清路一段79号6階</p>
                <p>
                  電話：
                  <a href="tel:+886422029858" className="text-[#2d5a27] hover:underline cursor-pointer">+886-4-2202-9858</a>
                </p>
                <p>
                  メール：
                  <a href="mailto:natural1070606@gmail.com" className="text-[#2d5a27] hover:underline cursor-pointer">natural1070606@gmail.com</a>
                </p>
              </div>
            </section>
          </div>

          {/* Related legal links */}
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link
              to="/ja"
              className="inline-flex items-center gap-2 text-[#2d5a27] hover:text-[#1a3d18] text-sm font-medium transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              ホームに戻る
            </Link>
            <Link
              to="/ja/privacy-policy"
              className="inline-flex items-center gap-2 text-gray-500 hover:text-[#2d5a27] text-sm transition-colors cursor-pointer"
            >
              <i className="ri-shield-check-line" />
              プライバシーポリシーを見る
            </Link>
          </div>
        </div>
      </div>
    </JaLayout>
  );
}
